import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input } from 'angular-ts-decorators';
import template from './staff-members.component.html';
var StaffMembersComponent = (function () {
    function StaffMembersComponent(staff) {
        this.staff = staff;
        this.dimensions = 100;
        this.take = 5;
    }
    StaffMembersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.staff
            .getPhotos(Number(this.take), Number(this.dimensions))
            .then(function (photos) { _this.photos = photos; });
    };
    StaffMembersComponent.$inject = ['staff'];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], StaffMembersComponent.prototype, "dimensions", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], StaffMembersComponent.prototype, "plusText", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], StaffMembersComponent.prototype, "take", void 0);
    StaffMembersComponent = __decorate([
        Component({
            selector: 'staffMembers',
            template: template,
        }),
        __param(0, Inject('staff')),
        __metadata("design:paramtypes", [Object])
    ], StaffMembersComponent);
    return StaffMembersComponent;
}());
export { StaffMembersComponent };
